import React from 'react';
import lottie from 'lottie-web';
import PropTypes from 'prop-types';
import animation from './UnitStreak.json';
import {EVENT, STATE} from './UnitStreakPlayer.constants';

/**
 * UnitStreakPlayer
 *  - Handles Animation playback of UnitStreak Counter
 */

export class UnitStreakPlayer extends React.Component {
  constructor(props) {
    super(props);
    this.elementRef = React.createRef();
    this.state = {
      anime: null,
    };
  }

  playbackCompleted = (event) => {
    if (event.type === EVENT.COMPLETE) {
      this.state.anime.stop();
      this.props.playComplete(STATE.NEUTRAL.KEY);
    }
  };

  applyStateAction = (anime) => {
    switch (this.props.state) {
      case STATE.STREAK.KEY:
        anime.goToAndStop(STATE.STREAK.VALUE, true);
        break;
      case STATE.SUCCESS.KEY:
        anime.goToAndStop(STATE.SUCCESS.VALUE, true);
        break;
      case STATE.FAIL.KEY:
        anime.playSegments(STATE.FAIL.VALUE, true);
        break;
      case STATE.NEUTRAL.KEY:
      default:
        anime.goToAndStop(STATE.NEUTRAL.VALUE, true);
        break;
    }
  };

  componentDidMount() {
    let anime = getLottieInstance(this.elementRef.current);
    anime.addEventListener(EVENT.COMPLETE, this.playbackCompleted);
    this.setState({anime});
    this.applyStateAction(anime);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.state === STATE.FAIL.KEY) {
      // after FAIL action the frame number of animation changes
      // this needs to be reset for properly setting other states
      this.state.anime.playSegments([0, 25], true);
    }
    if (prevProps.state !== this.props.state) {
      this.applyStateAction(this.state.anime);
    }
  }

  componentWillUnmount() {
    this.state.anime.removeEventListener(
      EVENT.COMPLETE,
      this.playbackCompleted
    );
    this.setState({anime: null});
  }

  render() {
    return (
      <div className={this.props.className} ref={this.elementRef}>
        {this.props.children}
      </div>
    );
  }
}

UnitStreakPlayer.propTypes = {
  /**
   * ClassName to set on component
   */
  ClassName: PropTypes.string,
  /**
   * Current animation play state
   */
  state: PropTypes.oneOf(['NEUTRAL', 'STREAK', 'SUCCESS', 'FAIL']),
  /**
   * Callback for when Animation playback complete [ on PLAY state]
   */
  playComplete: PropTypes.func,
  /**
   * child Components
   */
  children: PropTypes.element,
};

UnitStreakPlayer.defaultProps = {
  state: 'NEUTRAL',
  playComplete: console.log,
};

function getLottieInstance(container) {
  return lottie.loadAnimation({
    loop: false,
    autoplay: false,
    container: container,
    animationData: animation,
  });
}
